// Âge en années révolues à partir d'une date ISO (AAAA-MM-JJ), null si invalide
export const calculerAge = (iso) => {
  const d = iso ? new Date(String(iso).slice(0, 10)) : null;
  if (!d || isNaN(d)) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  if (now.getMonth() < d.getMonth() || (now.getMonth() === d.getMonth() && now.getDate() < d.getDate())) age -= 1;
  return age >= 0 && age < 120 ? age : null;
};
